import React from 'react';
import { HardDriveDownload } from 'lucide-react';
import { formatBytes, useNas } from './NasProvider';

// Shown in task forms: tells whoever assigns the task that the book is already on the NAS.
export function NasTaskHint({ title, author = '' }) {
    const nas = useNas();
    if (!nas || !title || title.trim().length < 3) return null;
    const item = nas.findForTask({ id: '', bookTitle: title, author });
    if (!item) return null;
    return (
        <div className="nas-form-hint">
            <HardDriveDownload size={15} />
            <span><strong>Đã có trên Kho NAS:</strong> {item.work} · {item.author} ({item.audio} file, {formatBytes(item.bytes)}). Nhân viên tải từ NAS, không cần torrent.</span>
        </div>
    );
}

// Author suggestions merged from existing tasks and the NAS archive.
export function AuthorOptions({ id, authors = [] }) {
    const nas = useNas();
    const all = [...new Set([...authors, ...(nas?.suggestions.authors || [])].map(value => String(value || '').trim()).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b, 'vi'));
    return <datalist id={id}>{all.map(value => <option key={value} value={value} />)}</datalist>;
}
